// Commitment status pill — FE-041.

import type { CommitmentStatus } from "./types";


const META: Record<CommitmentStatus, { label: string; classes: string }> = {
  backlog:        { label: "Backlog",        classes: "bg-recessed text-text-secondary" },
  ready_for_work: { label: "Ready for work", classes: "bg-teal-tint text-teal" },
  in_progress:    { label: "In progress",    classes: "bg-sage-tint text-teal" },
  in_review:      { label: "In review",      classes: "bg-gold-tint text-text-primary" },
  done:           { label: "Done",           classes: "bg-sage-tint text-teal" },
  cancelled:      { label: "Cancelled",      classes: "bg-ember-tint text-ember-ink" },
};


export function CommitmentStatusBadge({
  status,
}: { status: CommitmentStatus }) {
  const meta = META[status];
  return (
    <span
      data-testid={`commitment-status-${status}`}
      data-status={status}
      className={[
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        meta.classes,
      ].join(" ")}
    >
      {meta.label}
    </span>
  );
}


export function statusLabel(status: CommitmentStatus): string {
  return META[status].label;
}
